import React from 'react';
import dynamic from 'next/dynamic';
import { useContextSelector } from 'use-context-selector';
import { CatalogContext } from '@context/catalog.context';

const DialogWrapper = dynamic(() => import('@components/catalog/my-sizes/my-sizes/dialog-wrapper/dialog-wrapper'), {
  ssr: false,
});

const CatalogMySizesModal = () => {
  const areMySizesApplicable = useContextSelector(CatalogContext, (v) => v.areMySizesApplicable);
  const mySizesDialogOpen = useContextSelector(CatalogContext, (v) => v.mySizesDialogOpen);
  const setMySizesDialogOpen = useContextSelector(CatalogContext, (v) => v.setMySizesDialogOpen);

  return (
    mySizesDialogOpen && (
      <DialogWrapper
        dialogOpen={mySizesDialogOpen}
        setDialogOpen={setMySizesDialogOpen}
        canActivateSizes={areMySizesApplicable}
      />
    )
  );
};

export default CatalogMySizesModal;
